import React from 'react';
import { observer } from 'mobx-react';
import { useMst, PageRoutes } from '../../../internal';
import { QuizListElementModelType } from '../../../models/domain/quiz/QuizListElementModel';
import { Button } from '../../../components/UI/buttons/regular/Button';
import { dateSRLocale } from '../../../utils/date';
import trashIcon from '../../../assets/icons/icons8_trash_32px.png';
import styles from './SviKvizovi.module.scss';

export const SviKvizovi = observer((): JSX.Element => {
  const {
    currentPage,
    router: { navigate },
  } = useMst();

  const quizList = currentPage.getQuizList();

  return (
    <div className={styles.PageContainer}>
      <table className={styles.Table}>
        <thead>
          <tr>
            <th>Naziv</th>
            <th>Tip</th>
            <th>Status</th>
            <th>Početak</th>
            <th>Kraj</th>
            <th>Kreiran</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {quizList.elements.map((quiz: QuizListElementModelType) => (
            <tr key={quiz.id}>
              <td>
                <span
                  className={styles.NameLink}
                  onClick={() =>
                    navigate({
                      newView: PageRoutes.KvizDetalji.id,
                      queryParams: { id: quiz.id },
                    })
                  }
                >
                  {quiz.name}
                </span>
              </td>
              <td>{quiz.quizType}</td>
              <td>{quiz.isActive ? 'Aktivan' : 'Neaktivan'}</td>
              <td>{dateSRLocale(new Date(quiz.startDate))}</td>
              <td>{dateSRLocale(new Date(quiz.endDate))}</td>
              <td>{dateSRLocale(new Date(quiz.createdAt))}</td>
              <td>
                <img
                  src={trashIcon}
                  alt="Obriši"
                  className={styles.DeleteIcon}
                  onClick={() => currentPage.deleteQuiz(quiz.id)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className={styles.AddButton}>
        <Button
          onClick={() => navigate({ newView: PageRoutes.KreirajKviz.id })}
        >
          Dodaj novi
        </Button>
      </div>
    </div>
  );
});
